import React from "react";
import LocaleIcon from "./LocaleIcon";
import { INK } from "../styles";
import type { LocaleRowProps } from "../types";

export default function LocaleRow({ locale, isSelected, onClick }: LocaleRowProps) {
  return (
    <button
      onClick={onClick}
      onMouseEnter={(e) => {
        if (!isSelected) e.currentTarget.style.background = "#F9FAFA";
      }}
      onMouseLeave={(e) => {
        if (!isSelected) e.currentTarget.style.background = "#fff";
      }}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        width: "100%",
        padding: "10px 14px",
        minHeight: 42,
        background: isSelected ? "#F1F5F5" : "#fff",
        border: "none",
        cursor: "pointer",
        fontSize: 14,
        color: INK,
        fontFamily: "inherit",
        textAlign: "left",
      }}
    >
      <LocaleIcon locale={locale} large />
      <span>{locale.label}</span>
    </button>
  );
}